// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import FastaUploadController from "./fasta_upload_controller"
application.register("fasta-upload", FastaUploadController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MsaViewerController from "./msa_viewer_controller"
application.register("msa-viewer", MsaViewerController)

import PhylotreeViewerController from "./phylotree_viewer_controller"
application.register("phylotree-viewer", PhylotreeViewerController)

import SequenceSelectionController from "./sequence_selection_controller"
application.register("sequence-selection", SequenceSelectionController)

import AutocompleteController from "./autocomplete_controller";
application.register("autocomplete", AutocompleteController);

import SubmissionFormController from "./submission_form_controller";
application.register("submission-form", SubmissionFormController);

import CustomDropdownController from "./custom_dropdown_controller";
application.register("custom-dropdown", CustomDropdownController);

import GenbankImportController from "./genbank_import_controller";
application.register("genbank-import", GenbankImportController);

import GenbankReviewController from "./genbank_review_controller";
application.register("genbank-review", GenbankReviewController);

import AntigenicRunFormController from "./antigenic_run_form_controller";
application.register("antigenic-run-form", AntigenicRunFormController);

import MetaFieldFormController from "./meta_field_form_controller";
application.register("meta-field-form", MetaFieldFormController);

import AntigenFormController from "./antigen_form_controller";
application.register("antigen-form", AntigenFormController);

import RemovableRowController from "./removable_row_controller";
application.register("removable-row", RemovableRowController);
